import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://goislandride.com';
const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

/**
 * PageSEO — drops unique title, meta, canonical, OG, twitter, and JSON-LD per page.
 *
 * @param {string} title       — unique page title
 * @param {string} description — unique meta description
 * @param {string} path        — route path, e.g. "/local-rides-staten-island"
 * @param {object[]} [schemas] — array of JSON-LD objects to inject
 */
export default function PageSEO({ title, description, path, schemas }) {
  const canonical = `${SITE_URL}${path}${path.endsWith('/') ? '' : '/'}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {schemas && schemas.map((schema) => (
        <script key={schema['@type'] || schema['@id'] || JSON.stringify(schema).slice(0, 40)} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
